import React from "react";
import { StyleSheet, View, ScrollView } from "react-native";
import { colors } from "src/assets";
import { ReviewCard } from "src/components";
import { NotFound } from "./components";
import { useReviewsByOffer } from "./hooks";
import { useRoute } from "@react-navigation/native";
import { RootStackScreenProps } from "src/navigation/types";

export type ReviewByOfferNavigationParam = {
  id: string;
};

export const ReviewByOfferScreen: React.FC = () => {
  const route = useRoute<RootStackScreenProps<"ReviewByOffer">["route"]>();
  const [items, loading] = useReviewsByOffer(route.params.id);
  return (
    <View
      style={[
        styles.container,
        items.length === 0 && !loading ? styles.notFound : {},
      ]}
    >
      {items.length > 0 ? (
        <ScrollView>
          {items.map((item) => (
            <ReviewCard
              key={item.id}
              review={item}
              containerStyle={styles.card}
              onPress={() => console.log("onReview...")}
            />
          ))}
        </ScrollView>
      ) : null}
      {items.length === 0 && !loading ? <NotFound /> : null}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: colors.white,
  },
  notFound: {
    backgroundColor: colors.gray1,
  },
  card: {
    marginVertical: 8,
    marginHorizontal: 8,
  },
});
